import { Box, useMediaQuery, Theme, SxProps } from '@mui/material';
import { getSideIllustration } from '@/components/feature/searchDirectory/getSideIllustration';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';

interface IllustrationProps {
  sx?: SxProps<Theme>;
}

export const Illustration = ({ sx }: IllustrationProps) => {
  const { seoSegmentId, serviceId } = usePageAttributes();
  const isMediumOrLargeViewport = useMediaQuery((theme: Theme) =>
    theme.breakpoints.between('md', 'xl')
  );
  const isLargestViewport = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));
  const sideIllustration = getSideIllustration({ seoSegmentId, serviceId });

  if (!sideIllustration) {
    return null;
  }

  return (
    <Box sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      {isMediumOrLargeViewport && sideIllustration.small}
      {isLargestViewport && sideIllustration.medium}
    </Box>
  );
};
